import { Box, Hidden } from "@mui/material";
import { ReactComponent as CloseIcon } from "../assets/images/close.svg";
import { ReactComponent as LogoIcon } from "../assets/images/logo.svg";
import {
  StepRoot,
  CloseRow,
  CloseButton,
  StepBody,
  StepTitle,
  StepSubtitle,
  FieldLabel,
  FieldGroup,
  DarkTextField,
  PrimaryButton,
} from "./ForgottenPasswordStyles";

const ForgottenPasswordPasswordStep = ({ password, setPassword, close, resetPassword }) => {
  return (
    <StepRoot>
      <CloseRow>
        <CloseButton onClick={close}>
          <CloseIcon />
        </CloseButton>
      </CloseRow>

      <StepBody>
        <StepTitle>הגדר סיסמה חדשה</StepTitle>
        <StepSubtitle>הזן את הסיסמה החדשה שלך למטה</StepSubtitle>

        <FieldGroup>
          <FieldLabel>סיסמה חדשה</FieldLabel>
          <DarkTextField
            value={password.password}
            onChange={(event) =>
              setPassword((prv) => ({ ...prv, password: event.target.value }))
            }
            type="password"
            id="password"
            variant="outlined"
          />
        </FieldGroup>

        <FieldGroup>
          <FieldLabel>סיסמה חדשה בשנית</FieldLabel>
          <DarkTextField
            value={password.secondPassword}
            onChange={(event) =>
              setPassword((prv) => ({ ...prv, secondPassword: event.target.value }))
            }
            type="password"
            id="second-password"
            variant="outlined"
          />
        </FieldGroup>

        <FieldGroup sx={{ marginBottom: 0 }}>
          <PrimaryButton
            onClick={resetPassword}
            disabled={password.password !== password.secondPassword || password.password === ""}
            variant="contained"
          >
            שלח
          </PrimaryButton>
        </FieldGroup>
      </StepBody>

      <Hidden mdUp>
        <Box sx={{ textAlign: "center", pb: "28px", "& svg": { height: "34px" } }}>
          <LogoIcon />
        </Box>
      </Hidden>
    </StepRoot>
  );
};

export default ForgottenPasswordPasswordStep;
